import type { Singleton } from '../../compliance-shared/types/compliance';
import type { StandardTaskBrief } from '../../compliance-shared/types/standard-tasks';

export function standardTaskMapToSortedList(record: Singleton.StandardTasks): StandardTaskBrief[] {
  return Object.values(record).sort((a, b) => {
    const programA = a.id.replace(/[0-9]+$/, '');
    const programB = b.id.replace(/[0-9]+$/, '');
    const programDiff = programA.localeCompare(programB);
    if (programDiff !== 0) {
      return programDiff;
    }

    const indexA = Number(a.id.replace(/^[a-zA-Z]+/, ''));
    const indexB = Number(b.id.replace(/^[a-zA-Z]+/, ''));
    return indexA - indexB;
  });
}
